import { useLanguage, useTranslations } from './service';
import { PlaceCenter } from '../components/PlaceCenter';
import { Spinner } from '../components/Spinner';
import { IntlProvider } from 'react-intl';
import { Subscribe } from '@react-rxjs/core';
import { LFC } from '../types';

const fallback = (
  <PlaceCenter>
    <Spinner />
  </PlaceCenter>
);

export const I18nProvider: LFC = ({ children }) => (
  <Subscribe fallback={fallback}>
    <I18nProviderSubscribed>{children}</I18nProviderSubscribed>
  </Subscribe>
);

const I18nProviderSubscribed: LFC = ({ children }) => {
  const messages = useTranslations();
  const language = useLanguage();

  return (
    <IntlProvider locale={language.slice(0, 2)} messages={messages}>
      {children}
    </IntlProvider>
  );
};
